import { globalGraphqlRequest } from 'core/utils/backend-service';
import { mapTrainingProgramConfigFromApiToVm, mapTrainingProgramConfigFromVmToApi, VM } from '../domain';
import { getTrainingProgramsConfig, updateTrainingProgramsConfig } from './training-program-settings.queries';

export const getTrainingProgramsSettings = (): Promise<VM.TrainingProgramsConfig> =>
    globalGraphqlRequest(getTrainingProgramsConfig()).then((response) =>
        mapTrainingProgramConfigFromApiToVm(response.data.trainingProgramsConfig)
    );

export const updateTrainingProgramsSettings = (
    trainingProgramConfig: VM.TrainingProgramsConfig
): Promise<{ result: string }> =>
    globalGraphqlRequest(updateTrainingProgramsConfig(), {
        configuration: mapTrainingProgramConfigFromVmToApi(trainingProgramConfig),
    }).then(() => ({
        result: 'ok',
    }));
